/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_DeactivatedInputs */

const cs_templates_deactivated = /** @type {(inputs: Templates_DeactivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona deaktivována`)
};

const en_templates_deactivated = /** @type {(inputs: Templates_DeactivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template deactivated`)
};

/**
* | output |
* | --- |
* | "Template deactivated" |
*
* @param {Templates_DeactivatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_deactivated = /** @type {((inputs?: Templates_DeactivatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_DeactivatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_deactivated(inputs)
	return cs_templates_deactivated(inputs)
});